const DISMISS_KEY = 'xgain-walkthrough-dismissed';

const normalizeUserId = (userId) => {
  if (userId == null || userId === '') return '';
  return String(userId);
};

const sessionSkipKey = (userId) => `xgain-walkthrough-skip-${normalizeUserId(userId)}`;

export const isWalkthroughDismissed = (userId) => {
  const id = normalizeUserId(userId);
  if (!id) return true;
  try {
    const raw = localStorage.getItem(DISMISS_KEY);
    const dismissed = raw ? JSON.parse(raw) : {};
    return Boolean(dismissed[id]);
  } catch {
    return false;
  }
};

export const dismissWalkthroughPermanently = (userId) => {
  const id = normalizeUserId(userId);
  if (!id) return;
  try {
    const raw = localStorage.getItem(DISMISS_KEY);
    const dismissed = raw ? JSON.parse(raw) : {};
    dismissed[id] = true;
    localStorage.setItem(DISMISS_KEY, JSON.stringify(dismissed));
  } catch {
    // ignore storage errors
  }
};

export const skipWalkthroughForSession = (userId) => {
  const id = normalizeUserId(userId);
  if (!id) return;
  try {
    sessionStorage.setItem(sessionSkipKey(id), '1');
  } catch {
    // ignore storage errors
  }
};

export const isWalkthroughSkippedForSession = (userId) => {
  const id = normalizeUserId(userId);
  if (!id) return false;
  try {
    return sessionStorage.getItem(sessionSkipKey(id)) === '1';
  } catch {
    return false;
  }
};

/** Login/logout call localStorage.clear(); keep tour opt-out per user. */
export const clearLocalStoragePreservingWalkthrough = () => {
  let dismissedSnapshot = null;
  try {
    dismissedSnapshot = localStorage.getItem(DISMISS_KEY);
  } catch {
    // ignore storage errors
  }
  try {
    localStorage.clear();
    if (dismissedSnapshot != null) {
      localStorage.setItem(DISMISS_KEY, dismissedSnapshot);
    }
  } catch {
    // ignore storage errors
  }
};

export const OPEN_ADD_COIN_EVENT = 'xgain:open-add-coin';

export const requestOpenAddCoinModal = () => {
  window.dispatchEvent(new CustomEvent(OPEN_ADD_COIN_EVENT));
};
